var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.791,
    height: 246.094,
    viewBox: "0 0 233.791 246.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3749",
    "data-name": "Group 3749",
    transform: "translate(0.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3750",
    "data-name": "Group 3750",
    transform: "translate(89.655 184.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3573",
    "data-name": "Group 3573",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3477",
    "data-name": "Group 3477",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3476",
    "data-name": "Group 3476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3475",
    "data-name": "Group 3475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3474",
    "data-name": "Group 3474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3473",
    "data-name": "Group 3473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3472",
    "data-name": "Group 3472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3471",
    "data-name": "Group 3471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3470",
    "data-name": "Group 3470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3469",
    "data-name": "Group 3469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3468",
    "data-name": "Group 3468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3467",
    "data-name": "Group 3467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3466",
    "data-name": "Group 3466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3465",
    "data-name": "Group 3465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3464",
    "data-name": "Group 3464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3463",
    "data-name": "Group 3463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M628.9,437.568l-17.347,18s13.109,23.652,10.239,27.291l-37.35-32.35,25.837-29.158Z",
    transform: "translate(-584.445 -421.353)",
    fill: "#7b6bd9"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3493",
    "data-name": "Group 3493",
    transform: "translate(14.194 22.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3492",
    "data-name": "Group 3492",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3491",
    "data-name": "Group 3491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3490",
    "data-name": "Group 3490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3489",
    "data-name": "Group 3489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3488",
    "data-name": "Group 3488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3487",
    "data-name": "Group 3487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3486",
    "data-name": "Group 3486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3485",
    "data-name": "Group 3485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3484",
    "data-name": "Group 3484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3483",
    "data-name": "Group 3483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3482",
    "data-name": "Group 3482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3481",
    "data-name": "Group 3481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3480",
    "data-name": "Group 3480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3479",
    "data-name": "Group 3479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3478",
    "data-name": "Group 3478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M601.4,444a2.012,2.012,0,0,0-2.562.769,1.907,1.907,0,0,0,.8,2.512,2.122,2.122,0,0,0,2.709-.828,2,2,0,0,0-1.125-2.528",
    transform: "translate(-598.638 -443.809)",
    fill: "#e0e0e0"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3508",
    "data-name": "Group 3508",
    transform: "translate(0 26.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3507",
    "data-name": "Group 3507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3506",
    "data-name": "Group 3506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3505",
    "data-name": "Group 3505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3504",
    "data-name": "Group 3504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3503",
    "data-name": "Group 3503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3502",
    "data-name": "Group 3502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3501",
    "data-name": "Group 3501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3500",
    "data-name": "Group 3500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3499",
    "data-name": "Group 3499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3498",
    "data-name": "Group 3498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3497",
    "data-name": "Group 3497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3496",
    "data-name": "Group 3496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3495",
    "data-name": "Group 3495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3494",
    "data-name": "Group 3494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M584.444,450.511l2.609-2.943L622.1,479.883a3.974,3.974,0,0,1-.285,3Z",
    transform: "translate(-584.444 -447.568)",
    fill: "#5e52a5"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3524",
    "data-name": "Group 3524",
    transform: "translate(22.665 32.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3523",
    "data-name": "Group 3523",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3522",
    "data-name": "Group 3522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3521",
    "data-name": "Group 3521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3520",
    "data-name": "Group 3520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3519",
    "data-name": "Group 3519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3518",
    "data-name": "Group 3518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3517",
    "data-name": "Group 3517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3516",
    "data-name": "Group 3516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3515",
    "data-name": "Group 3515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3514",
    "data-name": "Group 3514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3513",
    "data-name": "Group 3513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3512",
    "data-name": "Group 3512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3511",
    "data-name": "Group 3511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3510",
    "data-name": "Group 3510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3509",
    "data-name": "Group 3509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M612.326,455.911c-.164.171-1.148-.539-2.554-.75-1.4-.247-2.548.116-2.653-.1-.137-.18,1.079-1,2.777-.714C611.6,454.617,612.511,455.783,612.326,455.911Z",
    transform: "translate(-607.109 -454.288)",
    fill: "#fff"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3540",
    "data-name": "Group 3540",
    transform: "translate(25.564 38.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3539",
    "data-name": "Group 3539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3538",
    "data-name": "Group 3538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3537",
    "data-name": "Group 3537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3536",
    "data-name": "Group 3536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3535",
    "data-name": "Group 3535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3534",
    "data-name": "Group 3534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3533",
    "data-name": "Group 3533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3532",
    "data-name": "Group 3532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3531",
    "data-name": "Group 3531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3530",
    "data-name": "Group 3530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3529",
    "data-name": "Group 3529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3528",
    "data-name": "Group 3528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3527",
    "data-name": "Group 3527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3526",
    "data-name": "Group 3526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3525",
    "data-name": "Group 3525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M614.843,460.873c-.111.206-1.17-.178-2.458.031-1.294.172-2.173.843-2.348.677-.2-.12.6-1.263,2.209-1.492S614.99,460.7,614.843,460.873Z",
    transform: "translate(-610.008 -460.046)",
    fill: "#fff"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3556",
    "data-name": "Group 3556",
    transform: "translate(28.526 43.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3555",
    "data-name": "Group 3555",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3554",
    "data-name": "Group 3554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3553",
    "data-name": "Group 3553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3552",
    "data-name": "Group 3552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3551",
    "data-name": "Group 3551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3550",
    "data-name": "Group 3550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3549",
    "data-name": "Group 3549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3548",
    "data-name": "Group 3548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3547",
    "data-name": "Group 3547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3546",
    "data-name": "Group 3546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3545",
    "data-name": "Group 3545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3544",
    "data-name": "Group 3544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3543",
    "data-name": "Group 3543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3542",
    "data-name": "Group 3542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3541",
    "data-name": "Group 3541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M613.01,467.334c-.2-.106.336-1.207,1.669-1.766s2.531-.206,2.477.008c-.027.235-1.045.273-2.132.749C613.925,466.775,613.207,467.474,613.01,467.334Z",
    transform: "translate(-612.97 -465.263)",
    fill: "#fff"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3572",
    "data-name": "Group 3572",
    transform: "translate(27.294 26.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3571",
    "data-name": "Group 3571",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3570",
    "data-name": "Group 3570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3569",
    "data-name": "Group 3569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3568",
    "data-name": "Group 3568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3567",
    "data-name": "Group 3567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3566",
    "data-name": "Group 3566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3565",
    "data-name": "Group 3565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3564",
    "data-name": "Group 3564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3563",
    "data-name": "Group 3563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3562",
    "data-name": "Group 3562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3561",
    "data-name": "Group 3561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3560",
    "data-name": "Group 3560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3559",
    "data-name": "Group 3559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3558",
    "data-name": "Group 3558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3557",
    "data-name": "Group 3557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M615.808,451.37c-.221.094-.84-.874-1.932-1.7-1.076-.847-2.178-1.208-2.137-1.442.008-.219,1.376-.192,2.649.8S616.022,451.309,615.808,451.37Z",
    transform: "translate(-611.738 -448.117)",
    fill: "#fff"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3459",
    "data-name": "Group 3459",
    transform: "translate(41.915 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3454",
    "data-name": "Group 3454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M583.269,257.7a5.492,5.492,0,0,0,1.344-3.583c-.131-1.784-.968-2.5-2.394-3.606h0c.66-1.5,1.639-3.771.831-5.2a5.52,5.52,0,0,0-4.584-2.724c.495-2.944-3.123-5.545-6.156-5.673-2.333-.1-4.605-.792-6.986,2.378,0,0-.709-2.5-5.141-1.894-2.156.294-4.61,2.34-4.816,4.471-1.175-2.23-4-2.552-6.388-1.666s-4.03,2.859-3.416,5.3a5.619,5.619,0,0,0-4.9,2.633,5.421,5.421,0,0,0-.008,5.488,3.838,3.838,0,0,0,.137,7.27l36.836,2.436c.017,0,.034-.006.051-.008l1.769,1.269a3.738,3.738,0,0,0,4.644-2.43C584.994,260.064,583.838,258.764,583.269,257.7Z",
    transform: "translate(-536.704 -236.788)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450",
    transform: "translate(0 8.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_26",
    "data-name": "Union 26",
    d: "M6.379,61.035,5.223,58.49,5.9,38.309c-2.088.063-6.138-.662-5.885-6.016C.2,28.244,2.5,27.3,4.5,27.272a2.82,2.82,0,0,1,1.742.561L6.51,19.92C6.424,8.968,12.835-.216,23.978,0L25,.081a19.726,19.726,0,0,1,18.37,19.482C43.4,29.058,43.3,39.547,42.83,44.6c-.967,10.47-11.759,11.28-11.759,11.28l-1.082,9.8L23.06,86.352Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3348",
    "data-name": "Group 3348",
    transform: "translate(17.512 50.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3347",
    "data-name": "Group 3347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3346",
    "data-name": "Group 3346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3345",
    "data-name": "Group 3345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3344",
    "data-name": "Group 3344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3343",
    "data-name": "Group 3343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3342",
    "data-name": "Group 3342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3341",
    "data-name": "Group 3341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3340",
    "data-name": "Group 3340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3339",
    "data-name": "Group 3339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6536",
    "data-name": "Path 6536",
    d: "M567.761,301.624a26.2,26.2,0,0,1-13.544-5.117s2.663,7.813,13.271,7.71Z",
    transform: "translate(-554.217 -296.507)",
    fill: "#6f4439"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3361",
    "data-name": "Group 3361",
    transform: "translate(36.235 27.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3360",
    "data-name": "Group 3360",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3359",
    "data-name": "Group 3359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3358",
    "data-name": "Group 3358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3357",
    "data-name": "Group 3357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3356",
    "data-name": "Group 3356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3355",
    "data-name": "Group 3355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3354",
    "data-name": "Group 3354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3353",
    "data-name": "Group 3353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3352",
    "data-name": "Group 3352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3351",
    "data-name": "Group 3351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3350",
    "data-name": "Group 3350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3349",
    "data-name": "Group 3349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    d: "M575.991,275.108a1.517,1.517,0,0,1-1.588,1.4,1.447,1.447,0,0,1-1.462-1.47,1.519,1.519,0,0,1,1.587-1.4A1.45,1.45,0,0,1,575.991,275.108Z",
    transform: "translate(-572.94 -273.636)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3375",
    "data-name": "Group 3375",
    transform: "translate(34.741 23.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3374",
    "data-name": "Group 3374",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3373",
    "data-name": "Group 3373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3372",
    "data-name": "Group 3372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3371",
    "data-name": "Group 3371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3370",
    "data-name": "Group 3370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3369",
    "data-name": "Group 3369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3368",
    "data-name": "Group 3368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3367",
    "data-name": "Group 3367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3366",
    "data-name": "Group 3366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3365",
    "data-name": "Group 3365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3364",
    "data-name": "Group 3364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3363",
    "data-name": "Group 3363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3362",
    "data-name": "Group 3362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6538",
    "data-name": "Path 6538",
    d: "M577.456,270.785c-.2.18-1.29-.748-2.929-.87-1.635-.145-2.9.591-3.065.381-.081-.1.14-.432.693-.766a4.242,4.242,0,0,1,2.473-.546,4.056,4.056,0,0,1,2.312.935C577.414,270.338,577.556,270.7,577.456,270.785Z",
    transform: "translate(-571.446 -268.97)",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3388",
    "data-name": "Group 3388",
    transform: "translate(22.366 27.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3387",
    "data-name": "Group 3387",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3386",
    "data-name": "Group 3386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3385",
    "data-name": "Group 3385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3384",
    "data-name": "Group 3384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3383",
    "data-name": "Group 3383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3382",
    "data-name": "Group 3382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3381",
    "data-name": "Group 3381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3380",
    "data-name": "Group 3380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3379",
    "data-name": "Group 3379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3378",
    "data-name": "Group 3378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3376",
    "data-name": "Group 3376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6539",
    "data-name": "Path 6539",
    d: "M562.122,274.368a1.516,1.516,0,0,1-1.588,1.4,1.447,1.447,0,0,1-1.462-1.47,1.519,1.519,0,0,1,1.587-1.4A1.449,1.449,0,0,1,562.122,274.368Z",
    transform: "translate(-559.071 -272.896)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3402",
    "data-name": "Group 3402",
    transform: "translate(19.087 21.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3401",
    "data-name": "Group 3401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3400",
    "data-name": "Group 3400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3399",
    "data-name": "Group 3399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3397",
    "data-name": "Group 3397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3396",
    "data-name": "Group 3396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3394",
    "data-name": "Group 3394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3393",
    "data-name": "Group 3393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3392",
    "data-name": "Group 3392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3391",
    "data-name": "Group 3391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3390",
    "data-name": "Group 3390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3389",
    "data-name": "Group 3389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6540",
    "data-name": "Path 6540",
    d: "M561.8,269.353c-.205.181-1.292-.747-2.93-.869-1.635-.144-2.9.591-3.065.38-.08-.094.138-.431.694-.765a4.246,4.246,0,0,1,2.472-.547,4.07,4.07,0,0,1,2.313.936C561.758,268.907,561.9,269.273,561.8,269.353Z",
    transform: "translate(-555.791 -267.538)",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3415",
    "data-name": "Group 3415",
    transform: "translate(29.541 22.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3414",
    "data-name": "Group 3414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3413",
    "data-name": "Group 3413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3412",
    "data-name": "Group 3412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3411",
    "data-name": "Group 3411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3410",
    "data-name": "Group 3410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3409",
    "data-name": "Group 3409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3408",
    "data-name": "Group 3408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3407",
    "data-name": "Group 3407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3406",
    "data-name": "Group 3406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3405",
    "data-name": "Group 3405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3404",
    "data-name": "Group 3404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3403",
    "data-name": "Group 3403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6541",
    "data-name": "Path 6541",
    d: "M566.246,281.7a11.046,11.046,0,0,1,2.7-.267c.422-.01.824-.061.917-.336a2.068,2.068,0,0,0-.182-1.241q-.471-1.538-.987-3.227c-1.363-4.591-2.314-8.352-2.126-8.4s1.446,3.626,2.809,8.217q.489,1.7.934,3.241a2.35,2.35,0,0,1,.088,1.631,1.051,1.051,0,0,1-.736.548,2.869,2.869,0,0,1-.718.042A10.872,10.872,0,0,1,566.246,281.7Z",
    transform: "translate(-566.246 -268.228)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3424",
    "data-name": "Group 3424",
    transform: "translate(18.836 17.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3423",
    "data-name": "Group 3423",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3422",
    "data-name": "Group 3422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3421",
    "data-name": "Group 3421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3420",
    "data-name": "Group 3420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3419",
    "data-name": "Group 3419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3418",
    "data-name": "Group 3418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3417",
    "data-name": "Group 3417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3416",
    "data-name": "Group 3416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6542",
    "data-name": "Path 6542",
    d: "M562.189,264.755c-.228.4-1.609-.081-3.325-.186-1.714-.142-3.172.137-3.316-.293-.061-.2.256-.563.886-.873a5.2,5.2,0,0,1,2.6-.463,4.981,4.981,0,0,1,2.464.828C562.051,264.163,562.291,264.562,562.189,264.755Z",
    transform: "translate(-555.541 -262.926)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3433",
    "data-name": "Group 3433",
    transform: "translate(35.136 18.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3432",
    "data-name": "Group 3432",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3431",
    "data-name": "Group 3431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3430",
    "data-name": "Group 3430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3429",
    "data-name": "Group 3429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3428",
    "data-name": "Group 3428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3427",
    "data-name": "Group 3427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3426",
    "data-name": "Group 3426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3425",
    "data-name": "Group 3425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6543",
    "data-name": "Path 6543",
    d: "M577.436,266.339c-.287.368-1.42-.008-2.782-.021-1.36-.059-2.513.256-2.779-.126-.117-.186.062-.554.565-.9a4.087,4.087,0,0,1,4.482.119C577.4,265.783,577.563,266.16,577.436,266.339Z",
    transform: "translate(-571.84 -264.677)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3449",
    "data-name": "Group 3449",
    transform: "translate(2.497 29.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3448",
    "data-name": "Group 3448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3447",
    "data-name": "Group 3447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3446",
    "data-name": "Group 3446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3445",
    "data-name": "Group 3445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3444",
    "data-name": "Group 3444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3443",
    "data-name": "Group 3443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3442",
    "data-name": "Group 3442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    d: "M542.342,281.075c-.031-.024-.132.082-.352.169a1.29,1.29,0,0,1-.952-.024,3.081,3.081,0,0,1-1.326-2.844,4.078,4.078,0,0,1,.441-1.775,1.461,1.461,0,0,1,1-.917.651.651,0,0,1,.735.377c.089.2.036.347.074.361.019.019.162-.113.117-.413a.794.794,0,0,0-.266-.463.971.971,0,0,0-.7-.214,1.785,1.785,0,0,0-1.382,1.052,4.2,4.2,0,0,0-.536,1.982c-.021,1.45.669,2.838,1.711,3.186a1.384,1.384,0,0,0,1.173-.136C542.32,281.248,542.366,281.09,542.342,281.075Z",
    transform: "translate(-539.202 -275.33)",
    fill: "#6f4439"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3451",
    "data-name": "Group 3451",
    transform: "translate(24.071 47.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M561.988,283.957a.641.641,0,0,0-.475-.128.577.577,0,0,0-.312.308,3.566,3.566,0,0,0,.063,3.492l.019.031a2.466,2.466,0,0,0,4.163-.119l.691-1.146C565.186,285.838,562.938,284.514,561.988,283.957Z",
    transform: "translate(-560.775 -283.816)",
    fill: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3453",
    "data-name": "Group 3453",
    transform: "translate(23.9 46.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3452",
    "data-name": "Group 3452",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M564.989,288.094c.058.024-.555.688-1.893.716a2.1,2.1,0,0,1-1.05-.276,2.368,2.368,0,0,1-.939-.818,4.249,4.249,0,0,1-.462-2.683,4.923,4.923,0,0,1,.13-.715,1.036,1.036,0,0,1,.505-.678.889.889,0,0,1,.836.123l.533.334,1.821,1.171a8.4,8.4,0,0,1,1.613,1.18,8.39,8.39,0,0,1-1.792-.9l-1.875-1.084c-.339-.183-.776-.527-.936-.408-.218.1-.31.6-.358,1.028a4.011,4.011,0,0,0,.363,2.4,2.006,2.006,0,0,0,.757.7,1.763,1.763,0,0,0,.869.283A4.367,4.367,0,0,0,564.989,288.094Z",
    transform: "translate(-560.605 -283.579)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3455",
    "data-name": "Group 3455",
    transform: "translate(14.764 28.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M565.319,272.022c-.057.006-.055-.6-.376-1.606a6.7,6.7,0,0,0-8.864-4.113,6.489,6.489,0,0,0-2.951,2.35,6.324,6.324,0,0,0,.292,7.631,6.514,6.514,0,0,0,3.118,2.125,6.716,6.716,0,0,0,6.163-1.1,6.643,6.643,0,0,0,2.366-3.653c.243-1.029.2-1.632.252-1.631a1.342,1.342,0,0,1,.047.432,5.149,5.149,0,0,1-.1,1.241,6.641,6.641,0,0,1-2.333,3.9,7.056,7.056,0,0,1-6.538,1.274,6.953,6.953,0,0,1-3.37-2.261,6.871,6.871,0,0,1,2.878-10.749,7.056,7.056,0,0,1,6.613.791,6.656,6.656,0,0,1,2.622,3.71,5.194,5.194,0,0,1,.2,1.23A1.367,1.367,0,0,1,565.319,272.022Z",
    transform: "translate(-551.468 -265.374)",
    fill: "#962cc6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3456",
    "data-name": "Group 3456",
    transform: "translate(31.848 30.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M582.4,273.471c-.057.006-.055-.6-.376-1.607a6.7,6.7,0,0,0-8.864-4.112,6.485,6.485,0,0,0-2.95,2.349,6.323,6.323,0,0,0,.291,7.632,6.514,6.514,0,0,0,3.118,2.125,6.716,6.716,0,0,0,6.163-1.1,6.636,6.636,0,0,0,2.366-3.653c.243-1.028.2-1.631.252-1.63a1.343,1.343,0,0,1,.047.432,5.146,5.146,0,0,1-.1,1.241,6.641,6.641,0,0,1-2.333,3.9,7.055,7.055,0,0,1-6.537,1.274,6.956,6.956,0,0,1-3.371-2.261,6.871,6.871,0,0,1,2.878-10.749,7.058,7.058,0,0,1,6.613.79,6.656,6.656,0,0,1,2.622,3.711,5.141,5.141,0,0,1,.2,1.23A1.373,1.373,0,0,1,582.4,273.471Z",
    transform: "translate(-568.553 -266.823)",
    fill: "#962cc6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3457",
    "data-name": "Group 3457",
    transform: "translate(28.52 34.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M568.984,273.146c-.119.079-.662-.776-1.749-.994s-1.926.34-2,.219c-.043-.051.1-.277.477-.489a2.407,2.407,0,0,1,1.63-.24,2.379,2.379,0,0,1,1.4.865C569,272.85,569.043,273.118,568.984,273.146Z",
    transform: "translate(-565.225 -271.593)",
    fill: "#962cc6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3458",
    "data-name": "Group 3458",
    transform: "translate(5.312 34.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M551.7,271.617a46.725,46.725,0,0,1-9.68,1.84,46.69,46.69,0,0,1,9.68-1.84Z",
    transform: "translate(-542.017 -271.582)",
    fill: "#962cc6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M575.885,250.636a1.26,1.26,0,0,0,.431-.607,2.114,2.114,0,0,0-.223-1.547,4.812,4.812,0,0,0-5.762-2.5,7.1,7.1,0,0,0-5.388-5.667,6.921,6.921,0,0,0-7,3.3A6.649,6.649,0,0,0,551.9,241.4a7.293,7.293,0,0,0-5.23,4.108,4.96,4.96,0,0,0-5.389,1.526,5.954,5.954,0,0,0-.9,5.926,3.548,3.548,0,0,0-2.267,3.261c-.17,1.734.57,4.218,2.156,3.877-.659,1.168.156,3.249,1.033,4.184,0,2.22.151,3.6.19,5.609.079,4.141,2.081,3.835,2.081,3.835.268,8.325,3.516,7.021,6.038-8.631a2.145,2.145,0,0,0,.9-1.261c.139-.577.063-1.264.454-1.688a.975.975,0,0,1,.612-.3,5.277,5.277,0,0,0,3.961.074,5.155,5.155,0,0,0,2.941-3.116,2.07,2.07,0,0,0,2.58.229c.1-.061.193-.143.29-.213a5.74,5.74,0,0,0,3.2-3.01,2.933,2.933,0,0,1,.528-.234,3.337,3.337,0,0,0,3.822.233,5.117,5.117,0,0,0,2.205-3.782c.032-.251.035-.5.044-.755a4.227,4.227,0,0,1,2.9.579c3.1,1.779,5.385,8.559,5.385,8.559C579.947,256.617,578.286,253.253,575.885,250.636Z",
    transform: "translate(-536.705 -236.788)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3676",
    "data-name": "Group 3676",
    transform: "translate(12.097 141.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3579",
    "data-name": "Group 3579",
    transform: "translate(57.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3462",
    "data-name": "Group 3462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3461",
    "data-name": "Group 3461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3460",
    "data-name": "Group 3460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M580.833,385.591s46.344-5.165,53.917-6.426c14.489-2.414,28.983-.108,35.135,12.131,2.8,5.571-.75,16.321-9.243,24.305-6.336,5.956-37.8,37.238-37.8,37.238l-26.964-22.134L629.256,405.2l-64.691,8.93Z",
    transform: "translate(-564.565 -378.312)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3578",
    "data-name": "Group 3578",
    transform: "translate(31.316 52.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3577",
    "data-name": "Group 3577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3576",
    "data-name": "Group 3576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3575",
    "data-name": "Group 3575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M641.413,434.433a2.245,2.245,0,0,1-.334.395l-1.026,1.077-3.867,3.937L623.02,453.008l-.158.158-.173-.142-3.363-2.757-16.644-13.756-5.007-4.211-1.345-1.164a2.9,2.9,0,0,1-.448-.431,2.947,2.947,0,0,1,.511.356l1.405,1.094,5.109,4.092,16.736,13.646L623,452.654l-.33.015,13.283-13.052,3.972-3.834,1.087-1.018A2.271,2.271,0,0,1,641.413,434.433Z",
    transform: "translate(-595.881 -430.704)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3667",
    "data-name": "Group 3667",
    transform: "translate(161.46 54.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3666",
    "data-name": "Group 3666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3589",
    "data-name": "Group 3589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3588",
    "data-name": "Group 3588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3587",
    "data-name": "Group 3587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3586",
    "data-name": "Group 3586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3585",
    "data-name": "Group 3585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3584",
    "data-name": "Group 3584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3583",
    "data-name": "Group 3583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3582",
    "data-name": "Group 3582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3581",
    "data-name": "Group 3581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3580",
    "data-name": "Group 3580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M680.863,432.98l22.76,19.742,22.582,10.512a3.034,3.034,0,0,1,1.382,4.257h0a3.093,3.093,0,0,1-2.373,1.545c-6.382.669-29.871,3.015-31.454,1.478-1.833-1.779-25.414-19.257-25.414-19.257Z",
    transform: "translate(-668.346 -432.98)",
    fill: "#7b6bd9"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3599",
    "data-name": "Group 3599",
    transform: "translate(23.847 34.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3598",
    "data-name": "Group 3598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3597",
    "data-name": "Group 3597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3596",
    "data-name": "Group 3596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3595",
    "data-name": "Group 3595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3594",
    "data-name": "Group 3594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3593",
    "data-name": "Group 3593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3592",
    "data-name": "Group 3592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3591",
    "data-name": "Group 3591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3590",
    "data-name": "Group 3590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M727.587,467.491l-35.394,1.726,1.567,1.3a3.172,3.172,0,0,0,2.453.605c2.974-.014,11.185-.231,28.943-2.013a3.109,3.109,0,0,0,2.431-1.615Z",
    transform: "translate(-692.193 -467.491)",
    fill: "#5e52a5"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3610",
    "data-name": "Group 3610",
    transform: "translate(22.523 27.666)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3609",
    "data-name": "Group 3609",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3608",
    "data-name": "Group 3608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3607",
    "data-name": "Group 3607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3606",
    "data-name": "Group 3606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3605",
    "data-name": "Group 3605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3604",
    "data-name": "Group 3604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3603",
    "data-name": "Group 3603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3602",
    "data-name": "Group 3602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3601",
    "data-name": "Group 3601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3600",
    "data-name": "Group 3600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M692.18,460.7a1.887,1.887,0,0,1,2.211,1.169,1.773,1.773,0,0,1-1.16,2.165,1.991,1.991,0,0,1-2.335-1.25,1.848,1.848,0,0,1,1.461-2.121",
    transform: "translate(-690.869 -460.646)",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3621",
    "data-name": "Group 3621",
    transform: "translate(43.743 24.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3620",
    "data-name": "Group 3620",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3619",
    "data-name": "Group 3619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3618",
    "data-name": "Group 3618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3617",
    "data-name": "Group 3617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3616",
    "data-name": "Group 3616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3615",
    "data-name": "Group 3615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3614",
    "data-name": "Group 3614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3613",
    "data-name": "Group 3613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3612",
    "data-name": "Group 3612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3611",
    "data-name": "Group 3611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M712.975,464.306c.175-.075-.6-1.6-.09-3.5.45-1.913,1.858-2.9,1.74-3.05-.04-.067-.468.072-1,.543a4.749,4.749,0,0,0-1.386,2.35,4.7,4.7,0,0,0,.109,2.714C712.595,464.028,712.908,464.348,712.975,464.306Z",
    transform: "translate(-712.089 -457.744)",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3632",
    "data-name": "Group 3632",
    transform: "translate(48.837 26.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3631",
    "data-name": "Group 3631",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3630",
    "data-name": "Group 3630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3629",
    "data-name": "Group 3629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3628",
    "data-name": "Group 3628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3627",
    "data-name": "Group 3627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3626",
    "data-name": "Group 3626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3625",
    "data-name": "Group 3625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3624",
    "data-name": "Group 3624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3623",
    "data-name": "Group 3623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3622",
    "data-name": "Group 3622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M717.476,465.256c.194-.026.067-1.383.734-2.848.635-1.48,1.731-2.315,1.618-2.471-.062-.164-1.5.526-2.229,2.209C716.848,463.821,717.312,465.323,717.476,465.256Z",
    transform: "translate(-717.183 -459.914)",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3643",
    "data-name": "Group 3643",
    transform: "translate(37.75 22.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3642",
    "data-name": "Group 3642",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3641",
    "data-name": "Group 3641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3640",
    "data-name": "Group 3640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3639",
    "data-name": "Group 3639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3638",
    "data-name": "Group 3638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3637",
    "data-name": "Group 3637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3636",
    "data-name": "Group 3636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3635",
    "data-name": "Group 3635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3634",
    "data-name": "Group 3634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3633",
    "data-name": "Group 3633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M706.4,464.033c.2-.016,0-2.1.831-4.471.8-2.381,2.249-3.917,2.1-4.049-.092-.14-1.867,1.288-2.729,3.84C705.709,461.894,706.239,464.089,706.4,464.033Z",
    transform: "translate(-706.096 -455.504)",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3654",
    "data-name": "Group 3654",
    transform: "translate(30.579 19.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3653",
    "data-name": "Group 3653",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3651",
    "data-name": "Group 3651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3650",
    "data-name": "Group 3650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3649",
    "data-name": "Group 3649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3648",
    "data-name": "Group 3648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3647",
    "data-name": "Group 3647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3646",
    "data-name": "Group 3646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3645",
    "data-name": "Group 3645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3644",
    "data-name": "Group 3644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M698.969,458.6c.191.054.736-1.65,2.082-3.341,1.322-1.708,2.861-2.658,2.758-2.827-.06-.157-1.861.594-3.286,2.427C699.081,456.679,698.8,458.583,698.969,458.6Z",
    transform: "translate(-698.925 -452.412)",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3665",
    "data-name": "Group 3665",
    transform: "translate(25.479 16.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3664",
    "data-name": "Group 3664",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3663",
    "data-name": "Group 3663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3662",
    "data-name": "Group 3662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3661",
    "data-name": "Group 3661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3660",
    "data-name": "Group 3660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3659",
    "data-name": "Group 3659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3658",
    "data-name": "Group 3658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3657",
    "data-name": "Group 3657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3656",
    "data-name": "Group 3656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3655",
    "data-name": "Group 3655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6569",
    "data-name": "Path 6569",
    d: "M693.892,455.1c.195.04.508-1.868,2.073-3.534,1.528-1.7,3.427-2.2,3.366-2.386-.016-.078-.521-.069-1.281.2a6.674,6.674,0,0,0-2.579,1.745,6.538,6.538,0,0,0-1.506,2.7C693.769,454.6,693.812,455.09,693.892,455.1Z",
    transform: "translate(-693.825 -449.135)",
    fill: "#fff"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3675",
    "data-name": "Group 3675",
    transform: "translate(0 6.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3670",
    "data-name": "Group 3670",
    transform: "translate(0 0.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3669",
    "data-name": "Group 3669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3668",
    "data-name": "Group 3668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M506.886,405.844c.461,1.14-1.588,37.766,33.761,37.989,31.736.2,74.419-28.392,79.287-26.558,3.182,1.2,57.965,47.983,57.965,47.983l19.766-22.815S646.978,394.885,642,391.462c-10.672-7.334-18.179-7.279-35.737-4.154-15.708,2.8-54.2,15.358-54.2,15.358l-3.7-3.089Z",
    transform: "translate(-506.886 -385.308)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3674",
    "data-name": "Group 3674",
    transform: "translate(87.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3673",
    "data-name": "Group 3673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3672",
    "data-name": "Group 3672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3671",
    "data-name": "Group 3671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    d: "M594.86,391s.2-.089.6-.241.986-.379,1.769-.651c1.562-.557,3.882-1.34,6.926-2.181a87.016,87.016,0,0,1,11.275-2.337,46.876,46.876,0,0,1,7.2-.494,37.894,37.894,0,0,1,8.03,1,39.023,39.023,0,0,1,16.392,8.328c4.9,4.48,9.989,9.374,15.431,14.475l35.361,33.367.168.159-.151.174-2.728,3.146c-2.929,3.39-5.968,6.833-8.976,10-2.956,3.178-5.73,6.369-8.492,9.525l.084.163L646.7,439.049l-13.3-11.318-5.977-5.092-2.807-2.392c-.459-.388-.905-.787-1.364-1.125a7.933,7.933,0,0,0-1.488-.833,7.757,7.757,0,0,0-6.253.1l-5.236,2.524-8.343,4.021-5.243,2.507-1.361.639c-.307.142-.469.2-.469.2s.149-.088.45-.243l1.342-.677,5.205-2.58,8.31-4.087,5.225-2.558a8.053,8.053,0,0,1,6.5-.137,8.23,8.23,0,0,1,1.555.861c.488.357.929.75,1.39,1.136l2.816,2.38,6,5.071,13.329,11.282,31.083,26.342.084.163c2.743-3.2,5.575-6.478,8.312-9.87,2.683-3.4,5.421-6.624,8.338-9.983l2.686-3.1.016.333c-12.562-11.875-24.495-23.156-35.331-33.4-5.426-5.105-10.528-10.028-15.384-14.5a38.756,38.756,0,0,0-16.206-8.3,37.666,37.666,0,0,0-7.957-1.03,46.883,46.883,0,0,0-7.152.454A89.029,89.029,0,0,0,604.2,388.1c-3.046.812-5.373,1.566-6.944,2.092l-1.784.607C595.071,390.937,594.86,391,594.86,391Z",
    transform: "translate(-594.86 -385.087)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3682",
    "data-name": "Group 3682",
    transform: "translate(83.76 130.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3681",
    "data-name": "Group 3681",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3680",
    "data-name": "Group 3680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    d: "M588.749,367.411c.5.066,17.407,11.882,17.407,11.882s4.133-7.843,5.983-8.074,7.547,1.92,8.052,2.507,1.621.691,2.735.8,3.1,2.852,3.1,2.852l3.808,2.785s-1.2,2.182-1.513,2.557-2.887-.675-2.848-1.076.324,2.459-1.653,2.543a11.189,11.189,0,0,1-4.52-1.232l-.664-3.3-4.377-1.339-1.109,1.365s4.964,1,4.809,2.609a2.479,2.479,0,0,1-1.607,2.074l-4.106-.09-9.025,2.131s-23.684-5.147-24.552-7.792S581.808,366.492,588.749,367.411Z",
    transform: "translate(-578.55 -367.348)",
    fill: "#ae7461"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Union_25",
    "data-name": "Union 25",
    d: "M12.086,102.291s-2.277,1.662,1.024-11.157l.427-1.731c-4.08-1.223-7.091-2.326-8.158-3.154C.384,82.373-.68,74.88.364,68.724S9.47,29.293,11.892,21.285C15.91,8.006,28.894,4.262,32.948,3.4L33,3.181,47.139,0c10.167,8.057,22.4,10.244,25.61,3.366l7.939,2.71h0s11.728,4.577,13.118,14.319c1.158,8.124-1.415,29.759-1.378,31.226a5.072,5.072,0,0,0,1.241,3.5,8.081,8.081,0,0,1,2.179,4.8,18.88,18.88,0,0,1,2.967,4.745c1.048,2.36,12.339,10.479,12.339,10.479L102,82.423s-2.444.1-5.623.1c-5.709,0-13.792-.32-14.374-2.108l-.02.022c.435,2.007.8,3.5.8,3.5l.539,5.694s-11.277-.379-18.39,5.1A41.6,41.6,0,0,1,58.7,98.217l-.711,1.788s-.79-.165-2.175-.457a76.733,76.733,0,0,1-16.191,5.372,40.106,40.106,0,0,1-6.886.55A79.933,79.933,0,0,1,12.086,102.291Z",
    transform: "translate(0 66.851)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3748",
    "data-name": "Group 3748",
    transform: "translate(58.508 140.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3692",
    "data-name": "Group 3692",
    transform: "translate(0 9.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3691",
    "data-name": "Group 3691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3690",
    "data-name": "Group 3690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M558.222,389.206l5.376,2.271s4.622-2.7,5.3-2.953a100.681,100.681,0,0,1,11.692-1.417,23.645,23.645,0,0,0,3.853-.242l-10.992,6.65-6.96,9.115a21.32,21.32,0,0,1-5.925,1.014,27.522,27.522,0,0,1-7.339-1.451Z",
    transform: "translate(-553.228 -386.865)",
    fill: "#ae7461"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3728",
    "data-name": "Group 3728",
    transform: "translate(8.146 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3697",
    "data-name": "Group 3697",
    transform: "translate(0 0.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3696",
    "data-name": "Group 3696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3695",
    "data-name": "Group 3695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3694",
    "data-name": "Group 3694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3693",
    "data-name": "Group 3693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M586.618,389.025a1.48,1.48,0,0,1-1.133,1.206,1.77,1.77,0,0,1-.381.037c-.9-.012-1.334-1.676-1.334-1.676l-4.124.552s-5.886,7.338-7.966,9.423c-8.18,8.2-10.306,2.281-10.306,2.281l2.531-9.631,5.226-8.6s-.324.517-.2-.835,2.537-1.582,2.537-1.582c.168-.7,1.586-1.36,1.586-1.36l6.563-1.191a4.6,4.6,0,0,1,3.788,1.006l3.981,3.365s2.352,2.578,2.341,3.345a1.318,1.318,0,0,1-1.222,1.264s.3,2.068-.2,2.3a4.607,4.607,0,0,1-1.685.1Z",
    transform: "translate(-561.374 -377.573)",
    fill: "#ae7461"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3703",
    "data-name": "Group 3703",
    transform: "translate(9.91 8.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3702",
    "data-name": "Group 3702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3701",
    "data-name": "Group 3701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3700",
    "data-name": "Group 3700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3699",
    "data-name": "Group 3699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3698",
    "data-name": "Group 3698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M571.284,387.178c.027.063.846-.267,2.218-.617a20.405,20.405,0,0,1,5.47-.606,19.559,19.559,0,0,1,3.018.318,4.385,4.385,0,0,1,2.222.776.782.782,0,0,1,.162.764,1.1,1.1,0,0,1-.355.541c-.291.236-.535.208-.531.248-.012.014.251.112.628-.117a1.221,1.221,0,0,0,.483-.6,1.027,1.027,0,0,0-.155-1.02,2.119,2.119,0,0,0-1.061-.639c-.415-.118-.847-.236-1.317-.328a17.659,17.659,0,0,0-8.645.38A7.714,7.714,0,0,0,571.284,387.178Z",
    transform: "translate(-571.284 -385.532)",
    fill: "#6f4439"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3709",
    "data-name": "Group 3709",
    transform: "translate(10.704 11.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3708",
    "data-name": "Group 3708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3707",
    "data-name": "Group 3707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3706",
    "data-name": "Group 3706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3705",
    "data-name": "Group 3705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3704",
    "data-name": "Group 3704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M572.078,391.286c.044.115,2.591-.767,5.818-1.539s5.9-1.159,5.882-1.281a6.686,6.686,0,0,0-1.773.1,39.433,39.433,0,0,0-8.306,2A6.709,6.709,0,0,0,572.078,391.286Z",
    transform: "translate(-572.078 -388.439)",
    fill: "#6f4439"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3715",
    "data-name": "Group 3715",
    transform: "translate(10.855 4.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3714",
    "data-name": "Group 3714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3713",
    "data-name": "Group 3713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3712",
    "data-name": "Group 3712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3711",
    "data-name": "Group 3711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3710",
    "data-name": "Group 3710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M586.532,388.878a2.884,2.884,0,0,0-.127-.688,14.975,14.975,0,0,0-.564-1.826,8.085,8.085,0,0,0-.571-1.211,4.068,4.068,0,0,0-1.046-1.17,9.118,9.118,0,0,0-3.121-1.677,12.718,12.718,0,0,0-3.5-.594,11.654,11.654,0,0,0-2.866.415c-.792.209-1.418.416-1.849.563a2.337,2.337,0,0,0-.657.272,21.934,21.934,0,0,0,2.576-.549,12.677,12.677,0,0,1,2.794-.318,13.219,13.219,0,0,1,3.377.608,9.133,9.133,0,0,1,3.006,1.58,4.941,4.941,0,0,1,1.581,2.191C586.186,387.937,586.445,388.907,586.532,388.878Z",
    transform: "translate(-572.229 -381.712)",
    fill: "#6f4439"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3721",
    "data-name": "Group 3721",
    transform: "translate(12.478 1.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3720",
    "data-name": "Group 3720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3719",
    "data-name": "Group 3719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3718",
    "data-name": "Group 3718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3717",
    "data-name": "Group 3717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3716",
    "data-name": "Group 3716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M573.852,380.329c.018.06.975-.2,2.543-.486,1.528-.22,3.895-.817,5.84.759a22.457,22.457,0,0,1,4.723,3.926,13.084,13.084,0,0,1,1.327,2.153,1.759,1.759,0,0,0-.169-.673,6.488,6.488,0,0,0-.92-1.658,19.579,19.579,0,0,0-4.723-4.091,7.271,7.271,0,0,0-1.614-.854,4.8,4.8,0,0,0-1.706-.24,14.49,14.49,0,0,0-2.818.39A10.2,10.2,0,0,0,573.852,380.329Z",
    transform: "translate(-573.852 -379.164)",
    fill: "#6f4439"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3727",
    "data-name": "Group 3727",
    transform: "translate(2.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3726",
    "data-name": "Group 3726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3725",
    "data-name": "Group 3725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3724",
    "data-name": "Group 3724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3723",
    "data-name": "Group 3723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3722",
    "data-name": "Group 3722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    d: "M575.373,394.866a2.455,2.455,0,0,0,.288-.4l.8-1.158a45.407,45.407,0,0,1,3.289-4.076l-.085.044,4.127-.524-.185-.123a4.378,4.378,0,0,0,.367.921,1.843,1.843,0,0,0,.734.8,1.037,1.037,0,0,0,.594.078,1.457,1.457,0,0,0,.562-.135,1.661,1.661,0,0,0,.811-.825,1.719,1.719,0,0,0,.1-.279l.016-.073.008-.037,0-.018v0c.044-.035-.39.288-.205.152h.014l.14.013c.186.014.372.022.562.023a4.385,4.385,0,0,0,.579-.03,1.984,1.984,0,0,0,.3-.056.7.7,0,0,0,.342-.179,1.193,1.193,0,0,0,.226-.626,4.349,4.349,0,0,0,.03-.589,9.617,9.617,0,0,0-.089-1.168l-.18.225a1.558,1.558,0,0,0,1.309-.931,1.22,1.22,0,0,0,.028-.858,3.621,3.621,0,0,0-.371-.705,21.789,21.789,0,0,0-1.947-2.45l-.009-.009-.011-.01-2.123-1.795-1.346-1.138a8.078,8.078,0,0,0-1.42-1.066,4.453,4.453,0,0,0-1.713-.5,5.836,5.836,0,0,0-1.719.156l-6.183,1.139-.026.005-.02.01a5.939,5.939,0,0,0-.964.586,1.844,1.844,0,0,0-.715.9l.2-.134a2.312,2.312,0,0,0-2,.725,2.6,2.6,0,0,0-.515,1.881l.022-.1c-1.5,2.461-2.732,4.468-3.609,5.9l-.964,1.619a3.7,3.7,0,0,0-.31.581,3.667,3.667,0,0,0,.387-.534l1.035-1.576,3.728-5.832.025-.039,0-.057a2.3,2.3,0,0,1,.461-1.638,1.974,1.974,0,0,1,1.694-.59l.157.016.042-.15a1.557,1.557,0,0,1,.591-.7,5.532,5.532,0,0,1,.9-.538l-.046.014,6.188-1.105a5.469,5.469,0,0,1,1.61-.146,4.062,4.062,0,0,1,1.549.457,7.763,7.763,0,0,1,1.344,1.018l1.346,1.138,2.124,1.794-.02-.018a21.638,21.638,0,0,1,1.911,2.39,3.274,3.274,0,0,1,.333.62.838.838,0,0,1-.022.586,1.157,1.157,0,0,1-.964.677l-.207.028.026.2a9.2,9.2,0,0,1,.091,1.116,1.95,1.95,0,0,1-.151.957.389.389,0,0,1-.155.066,1.69,1.69,0,0,1-.247.047,4.2,4.2,0,0,1-.529.031c-.178,0-.357-.006-.533-.019l-.131-.01h-.012c.184-.136-.252.186-.207.154v0l0,.014-.006.029-.013.057a1.278,1.278,0,0,1-.077.221,1.3,1.3,0,0,1-.625.65,1.093,1.093,0,0,1-.439.105.681.681,0,0,1-.4-.039,2.528,2.528,0,0,1-.932-1.483l-.045-.142-.14.02-4.12.579-.053.008-.032.036a38.992,38.992,0,0,0-3.206,4.177c-.337.515-.584.921-.742,1.2A2.227,2.227,0,0,0,575.373,394.866Z",
    transform: "translate(-564.114 -377.343)",
    fill: "#6f4439"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3730",
    "data-name": "Group 3730",
    transform: "translate(79.938 90.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6584",
    "data-name": "Path 6584",
    d: "M583.736,327.381a1.952,1.952,0,0,1-.009.525L583.6,329.4c-.121,1.3-.321,3.169-.592,5.48-.542,4.623-1.383,11-2.573,18.005s-2.545,13.3-3.672,17.818c-.563,2.259-1.047,4.08-1.416,5.329-.173.576-.315,1.051-.43,1.436a2,2,0,0,1-.184.491,1.927,1.927,0,0,1,.083-.518c.09-.392.2-.874.335-1.461.314-1.341.737-3.155,1.253-5.362,1.034-4.533,2.327-10.825,3.518-17.821s2.086-13.355,2.72-17.963c.311-2.247.567-4.093.756-5.458.09-.6.165-1.084.225-1.482A2.05,2.05,0,0,1,583.736,327.381Z",
    transform: "translate(-574.728 -327.381)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3731",
    "data-name": "Group 3731",
    transform: "translate(24.128 104.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6585",
    "data-name": "Path 6585",
    d: "M552.78,403.644a1.189,1.189,0,0,1,.082-.3c.079-.226.177-.509.3-.86.29-.793.69-1.889,1.2-3.275l4.461-11.9.122.265-27.078-9.5-12.731-4.505-.213-.076.054-.218c2.26-9.16,4.209-17.06,5.606-22.721.7-2.771,1.267-4.991,1.667-6.566.2-.731.349-1.312.466-1.749a3.408,3.408,0,0,1,.189-.6,3.434,3.434,0,0,1-.106.618c-.1.441-.225,1.028-.386,1.767-.367,1.584-.883,3.815-1.527,6.6-1.352,5.671-3.238,13.587-5.425,22.764l-.159-.293,12.738,4.484,27.041,9.6.2.071-.076.194c-1.93,4.937-3.511,8.98-4.627,11.836-.55,1.369-.984,2.452-1.3,3.236l-.353.839A1.274,1.274,0,0,1,552.78,403.644Z",
    transform: "translate(-518.917 -341.645)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3732",
    "data-name": "Group 3732",
    transform: "translate(8.4 154.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6586",
    "data-name": "Path 6586",
    d: "M546.555,402.766a11.369,11.369,0,0,1-1.743-.286l-4.71-.965c-3.972-.837-9.46-2-15.481-3.476s-11.416-3.056-15.268-4.351c-1.927-.646-3.476-1.2-4.535-1.61a11.325,11.325,0,0,1-1.628-.682,11.458,11.458,0,0,1,1.7.491l4.58,1.451c3.874,1.2,9.267,2.722,15.28,4.195s11.485,2.693,15.437,3.623l4.675,1.126A11.375,11.375,0,0,1,546.555,402.766Z",
    transform: "translate(-503.19 -391.392)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3747",
    "data-name": "Group 3747",
    transform: "translate(82.174 102.808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3736",
    "data-name": "Group 3736",
    transform: "translate(0 40.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3735",
    "data-name": "Group 3735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3734",
    "data-name": "Group 3734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6587",
    "data-name": "Path 6587",
    d: "M577.02,393.591h0a1.625,1.625,0,0,0,1.913,1.142l33.221-7.142,28.539-5.109.241-2.49-27.278,3.847-35.423,7.779A1.594,1.594,0,0,0,577.02,393.591Z",
    transform: "translate(-576.963 -379.992)",
    fill: "#e0e0e0",
    stroke: "#25292b",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3739",
    "data-name": "Group 3739",
    transform: "translate(36.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3738",
    "data-name": "Group 3738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3737",
    "data-name": "Group 3737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6588",
    "data-name": "Path 6588",
    d: "M628.909,345.444,613.557,384.09a2.141,2.141,0,0,0,2.373,2.882l33.9-6.148a2.159,2.159,0,0,0,1.666-1.337l15.4-38.341a1.146,1.146,0,0,0-1.175-1.547l-34.967,4.5A2.163,2.163,0,0,0,628.909,345.444Z",
    transform: "translate(-613.403 -339.595)",
    fill: "#e0e0e0",
    stroke: "#25292b",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3743",
    "data-name": "Group 3743",
    transform: "translate(38.519 4.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3742",
    "data-name": "Group 3742",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3741",
    "data-name": "Group 3741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3740",
    "data-name": "Group 3740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6589",
    "data-name": "Path 6589",
    d: "M632.378,344.1c.128.049-3.551,9.671-8.215,21.489s-8.549,21.363-8.677,21.315,3.551-9.669,8.216-21.491S632.251,344.052,632.378,344.1Z",
    transform: "translate(-615.483 -344.1)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3746",
    "data-name": "Group 3746",
    transform: "translate(63.225 20.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3745",
    "data-name": "Group 3745",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3744",
    "data-name": "Group 3744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6590",
    "data-name": "Path 6590",
    d: "M640.868,362.374c-.956,1.863-.9,3.789.135,4.3s2.641-.586,3.6-2.45.9-3.789-.135-4.3S641.824,360.51,640.868,362.374Z",
    transform: "translate(-640.188 -359.799)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.ee57502a48c80ea9a6e2529cd0db1e7d.svg";
export { ForwardRef as ReactComponent };